import Box from 'fe-design-base/atoms/Box';
import Icon from 'fe-design-base/atoms/Icon';
import Text from 'fe-design-base/atoms/Text';
import moment from 'moment';

import { toI18n } from 'util/i18n';

interface AssistedClockOutNoteProps {
  comment?: string;
  submittedAt?: string;
}

const AssistedClockOutNote = ({
  comment,
  submittedAt,
}: AssistedClockOutNoteProps) => {
  if (!comment) return null;

  const submittedMoment = moment(submittedAt);
  const isToday = submittedMoment.isSame(moment(), 'day');

  const formattedTime = isToday
    ? submittedMoment.format('h:mm a')
    : submittedMoment.format('h:mm a, ddd, MMM D');

  return (
    <Box flex column gap={8}>
      <Box row gap={8}>
        <Icon iconName="Documents" size="small" />
        <Text variant="captionBold">
          {toI18n('timecard_modal_v3.issues.assisted_clock_out.note_title')}
        </Text>
      </Box>
      <Text variant="captions">"{comment}"</Text>
      <Text variant="captions" color="mono700">
        {submittedMoment.format('ddd, MMM D')} | {formattedTime}
      </Text>
    </Box>
  );
};

export default AssistedClockOutNote;
